<div
  class="option-container"
  [class.even]="isEven"
  [class.last]="isLast"
  *ngFor="let option of options; even as isEven; last as isLast"
>
  <button
    class="option"
    [class.selected-option]="option.value === bpFormControlName.value"
    (click)="setFormControlValue(option)"
  >
    <ion-icon [name]="option.icon" *ngIf="option.icon; else label"> </ion-icon>
    <ng-template #label>{{ option.label }}</ng-template>
  </button>
</div>
